import { FreeTrialFormData, FreeTrialRequest, FreeTrialResponse } from "../model/free-trial-types";
import { freeTrialAPI } from "../api/free-trial-api";
import { useState } from "react";

interface UsesFreeTrialReturn {
  submitFreeTrial: (data: FreeTrialFormData) => Promise<{ success: boolean }>;
  isLoading: boolean;
  error: string | null;
}

/**
 * 무료체험 신청 hook
 */
export function useFreeTrial(): UsesFreeTrialReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitFreeTrial = async (data: FreeTrialFormData) => {
    setIsLoading(true);
    setError(null);

    try {
      // FormData를 API 요청 형식으로 변환
      const requestData: FreeTrialRequest = {
        child: {
          name: data.child.name,
          age_group: data.child.age_group,
          birth_month: data.child.birth_month,
          birth_date: data.child.birth_date,
        },
        parent: {
          name: data.parent.name,
          gender: data.parent.gender,
          birth_date: data.parent.birth_date,
          user_id: data.parent.user_id,
          password: data.parent.password,
          phone_number: data.parent.phone_number,
          email: data.parent.email,
        },
        agree_to_terms: data.agree_to_terms,
        agree_to_privacy: data.agree_to_privacy,
        agree_to_marketing: data.agree_to_marketing,
        agree_to_parental_consent: data.agree_to_parental_consent,
      };

      const response = await freeTrialAPI.submitFreeTrial(requestData);

      if (response.success) {
        return { success: true };
      } else {
        setError(response.message || "무료체험 신청에 실패했습니다.");
        return { success: false };
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "알 수 없는 오류가 발생했습니다.";
      setError(errorMessage);
      console.error("Free trial submission failed:", errorMessage);
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return { submitFreeTrial, isLoading, error };
}
